import React, { Component } from "react";
import { Col } from "antd";

class WinPoints extends Component {
  render() {
    return (
      <Col style={{ marginTop: "30px" }}>
        <Col
          span={12}
          style={{ textAlign: "center", color: "#0000FE", fontSize: "18px" }}
        >
          <h3 style={{ color: "black", fontSize: "24px" }}>Obtenir des points</h3>

          <p>Prendre un cours particulier</p>
          <p>Rejoindre un cours</p>
          <p>Créer / Rejoindre un cours </p>
          <p>Créer / Rejoindre un cours en semaine test</p>
          <p>Partage Facebook</p>
          <p>Inviter un ami par mail</p>
          <p>3 séances urban par semaine</p>
          <p>Anniversaire</p>
          <p>Réengagement de 3 mois</p>
          <p>Réengagement de 6 mois</p>
          <p>Réengagement de 9 mois</p>
          <p>Réengagement de 12 mois</p>
          <p>Parrainage par abonnement</p>
        </Col>
        <Col span={12} style={{ textAlign: "center", fontSize: "18px" }}>
          <h3 style={{ color: "black", fontSize: "24px" }}>Points gagnés</h3>
          <p>10</p>
          <p>10</p>
          <p>10</p>
          <p>50</p>
          <p>50</p>
          <p>100</p>
          <p>500</p>
          <p>1000</p>
          <p>1000</p>
          <p>2500</p>
          <p>5000</p>
          <p>7500</p>
          <p>10000</p>
        </Col>
      </Col>
    );
  }
}

export default WinPoints;
